export default "__VITE_ASSET__nqVG87jf__"